/* global gtag */
import React, { useEffect } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { Card, CardContainer } from 'src/components/CardContainer';
import { Stack, Link, Divider } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

export default function TopUpComplete() {
  const queryParams = new URLSearchParams(window.location.search);
  const paymentIntent = queryParams.get('payment_intent');
  const redirectStatus = queryParams.get('redirect_status');
  const amount = queryParams.get('amount');
  const currency = queryParams.get('currency');

  if (!paymentIntent) {
    return <Navigate to="/" replace />;
  }

  if (redirectStatus == "succeeded") {
    // Payment was successful, add the conversion tracking script
    gtag('event', 'conversion', {
      'send_to': 'AW-16812578454/gt1JCPvCl_QZEJat7tA-',
      'value': amount,
      'currency': currency
    });
    return <PaymentSucceed />
  }
  return <PaymentFail />
}

const PaymentSucceed = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = React.useState(15);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (countdown > 0) {
        setCountdown(prev => prev - 1);
      } else {
        navigate("/", { replace: true });
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown]);

  return (
    <CardContainer direction="column" justifyContent="space-between">
      <Card variant="outlined">
        <Stack spacing={1.5} alignItems="center" justifyContent="center">
          <CheckCircleIcon
            style={{ fontSize: '80px', color: '#4CAF50', marginBottom: '20px' }}
          />
          <Typography
            component="h1"
            variant="h5"
            align="center"
            color="#4CAF50"
            sx={{ width: '100%', fontSize: '2rem' }}
          >
            Payment Succeed!
          </Typography>
          <Typography
            variant="body1"
            color="textSecondary"
            align="center"
            style={{ marginTop: '20px' }}
          >
            You will be redirected to the main page in {countdown} seconds.
          </Typography>
          <Link href="/" align="center">
            <Typography variant="body1" color="textSecondary">Jump to Home Now</Typography>
          </Link>
        </Stack>
      </Card>
    </CardContainer>
  )
}

const PaymentFail = () => {
  return (
    <CardContainer direction="column" justifyContent="space-between">
      <Card variant="outlined">
        <Stack spacing={1.5} alignItems="center" justifyContent="center">
          <CancelIcon
            style={{ fontSize: '80px', color: '#F44336', marginBottom: '20px' }}
          />
          <Typography
            variant="h4"
            color="textPrimary"
            align="center"
          >
            Payment Failed!
          </Typography>
          <Typography
            variant="body1"
            color="textSecondary"
            align="center"
            style={{ marginTop: '20px' }}
          >
            Unfortunately, your payment could not be processed.
          </Typography>
          <Typography
            variant="body1"
            color="textSecondary"
            align="center"
          >
            Please try again, or contact{' '}
            <Link
              variant="body1"
              color="textSecondary"
              sx={{ alignSelf: 'center' }}
            >
              contact@fitu.sg
            </Link>
          </Typography>
        </Stack>
      </Card>
    </CardContainer>
  )
}
